/**
 * Delete Custom Checklist Task API
 * Feature: 020-thinka-and-create
 */

import axiosInstance from '../axiosInstance';

export interface DeleteCustomChecklistTaskResponse {
  message: string;
}

export const deleteCustomChecklistTask = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/api/custom-checklist-tasks/${id}`);
};
